module.exports = Em.CollectionView.extend({
    classNames: ['table-row'],

    createChildView: function(viewClass, attrs) {
        var column = attrs.content
        var view = this._super(column.get('cellViewClass'), {
            column: column,
            contentIndex: attrs.contentIndex
        })
        return view
    }
})
